import React, { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AbilityContext, createAbilityFromAuth } from '../config/abilityContext';
import { RootState } from '../redux/store';

interface AppWrapperProps { children: ReactNode; }

const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
  const { user, permissions, isSuperAdmin } = useSelector((s: RootState) => s.authSlice);
  const role = user?.role || 'guest';

  const ability = useMemo(
    () => createAbilityFromAuth({ role, permissions, isSuperAdmin }),
    [role, permissions, isSuperAdmin]
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};

export default AppWrapper;
